/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>地图管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" style="margin-top: 20px; heigth: 60px">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.map_name_cn" placeholder="输入地图名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="success" icon="el-icon-plus" @click="importMap"
          v-if="check_auth('/web/map/get_import')">导入地图数据</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row border style="width: 100%">
      <el-table-column prop="id" fixed="left" align="center" label="ID" width="80">
      </el-table-column>
      <el-table-column prop="map_name_cn" align="center" label="地图姓名" min-width="250">
      </el-table-column>
      <el-table-column prop="line_count" align="center" label="线路数量" min-width="180">
      </el-table-column>
      <el-table-column v-if="false" prop="company_id" align="center" label="公司id" min-width="80">
      </el-table-column>
      <el-table-column prop="company_name" align="center" label="公司名称" min-width="200">
      </el-table-column>
      <el-table-column prop="create_time" align="center" label="创建时间" min-width="250">
      </el-table-column>
      <el-table-column prop="update_time" align="center" label="更新时间" min-width="250">
      </el-table-column>
      <el-table-column prop="status" label="状态" min-width="100" align="center" header-align="center"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#e5e5e5"
            @change="changeSwitch(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="remark" align="center" label="备注" width="300">
      </el-table-column>

      <el-table-column align="center" fixed="right" label="操作" min-width="300"
        v-if="check_auth('/web/line/get_lines') || check_auth('/web/map/edit_remark') || check_auth('/web/map/del_map')">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="addLine(scope.row)"
            v-if="check_auth('/web/line/get_lines')">线路管理</el-button>
          <el-button size="mini" @click="editMap(scope.row)" v-if="check_auth('/web/map/edit_remark')">编辑</el-button>
          <el-button size="mini" type="danger" @click="delMap(scope.row)"
            v-if="check_auth('/web/map/get_import')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 添加界面 -->

    <el-dialog title="地图管理" :visible.sync="addFormVisible" width="70%" :close-on-click-modal="false">
      <el-form :inline="true" :model="importInline">
        <el-form-item label="搜索：">
          <el-input size="small" v-model="importInline.map_name_cn" placeholder="输入地图名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="importSearch">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="gridData" ref="multipleTable" row-key="id" @selection-change="handleSelectionChange">
        <el-table-column width="50" type="selection" fixed="left" reserve-selection></el-table-column>
        <el-table-column prop="id" align="center" label="ID" width="80">
        </el-table-column>
        <el-table-column prop="map_name_cn" align="center" label="地图名称" min-width="250">
        </el-table-column>
        <el-table-column prop="line_count" align="center" label="线路数量" min-width="180">
        </el-table-column>
        <el-table-column prop="createtime" align="center" label="创建时间" min-width="250">
        </el-table-column>
        <el-table-column prop="updatetime" align="center" label="更新时间" min-width="250">
        </el-table-column>
        <el-table-column prop="remark" align="center" label="备注" widmin-widthth="300">
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="importPage.currentPage" :page-size="importPage.pageSize" background :pager-count="5"
        layout="total, prev, pager, next" :total="importPage.total">
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="addImport">确认添加</el-button>
      </div>
    </el-dialog>
    <!-- 编辑界面 -->
    <el-dialog :visible.sync="editFormVisible" width="35%" :title="title" @click="closeDialog" :destroy-on-close="true"
      :close-on-click-modal="false">
      <el-form label-width="80px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="地图名称" prop="map_name_cn">
          <el-input size="small" v-model="editForm.map_name_cn" auto-complete="off" :disabled="true"
            placeholder="请输入地图名称"></el-input>
        </el-form-item>
        <el-form-item label="线路数量" prop="line_count">
          <el-input size="small" v-model="editForm.line_count" auto-complete="off" :disabled="true"
            placeholder="请输入地图名称"></el-input>
        </el-form-item>
        <el-form-item label="创建时间" prop="create_time">
          <el-input size="small" v-model="editForm.create_time" auto-complete="off" :disabled="true"
            placeholder="请输入创建时间"></el-input>
        </el-form-item>
        <el-form-item label="更新时间" prop="update_time">
          <el-input size="small" v-model="editForm.update_time" auto-complete="off" :disabled="true"
            placeholder="请输入更新时间"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input size="small" type="textarea" rows="3" v-model="editForm.remark" auto-complete="off"
            placeholder="请输入备注">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  get_map_list,
  get_import_list,
  get_import_map_add,
  get_one_map,
  get_map_edit,
  get_switch_status,
  get_del_map,
} from "../../api/map_mn/map_mn";
import { timestampToTime, auth } from "../../utils/util";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      editFormVisible: false, //控制编辑页面显示与隐藏
      addFormVisible: false, //控制编辑页面显示与隐藏
      value: true,
      title: "修改",
      formInline: {
        map_name_cn: "",
        page: 1,
        limit: 10,
      },
      importInline: {
        map_name_cn: "",
        page: 1,
        limit: 10,
      },
      listData: [],
      gridData: [],
      idsval: [],
      ids: [],
      editForm: {
        id: "",
        map_name: " ",
        map_name_cn: "",
        create_time: " ",
        update_time: " ",
        line_count: "",
        company_id: "",
        remark: " ",
      },
      // rules表单验证
      rules: {
        map_name_cn: [
          { required: true, message: "请输入地图名称", trigger: "blur" },
        ],
        line_count: [
          { required: true, message: "请输入线路数量", trigger: "blur" },
        ],
        create_time: [
          { required: true, message: "请输入创建时间", trigger: "blur" },
        ],
        update_time: [
          { required: true, message: "请输入更新时间", trigger: "blur" },
        ],

        remarks: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      importPage: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getData();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //跳转到线路管理0
    addLine(row) {
      window.localStorage.setItem("map_id", row.id);
      window.localStorage.setItem("company_id", row.company_id);
      this.$router.push("/map_mn/Line_mn");
    },
    // 获取地图列表
    getData() {
      window.localStorage.removeItem("map_id");
      window.localStorage.removeItem("company_id");
      get_map_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.listData = res.data.data;
          for (var i = 0; i < this.listData.length; i++) {
            this.listData[i].status =
              this.listData[i].status === 1 ? true : false;
          }
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res.data["total"];
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getData();
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getData();
    },
    importMap() {
      this.addFormVisible = true;
      this.getImport();
    },
    //导入地图
    getImport() {
      get_import_list(this.importInline).then((res) => {
        if (res["code"] === 0) {
          this.gridData = res.data.data;
          for (var i = 0; i < this.gridData.length; i++) {
            let time = this.gridData[i].createtime;
            if (time != null) {
              this.gridData[i].createtime = timestampToTime(time * 1000);
            }
            let times = this.gridData[i].updatetime;
            if (times != null) {
              this.gridData[i].updatetime = timestampToTime(times * 1000);
            }
          }
          this.importPage.currentPage = this.importInline.page;
          this.importPage.pageSize = this.importInline.limit;
          this.importPage.total = res.data["total"];
        }
      });
    },
    check_auth(val) {
      return auth(val);
    },
    // 导入搜索
    importSearch() {
      this.importInline.page = 1;
      this.getImport();
    },
    // 导入分页
    callCar() {
      this.importInline.page = this.importPage.currentPage;
      this.importInline.limit = this.importPage.pageSize;
      this.getImport();
    },
    //导入地图id
    handleSelectionChange(val) {
      this.idsval = [];
      for (let i in val) {
        //去重以免发生意外的push
        if (!this.idsval.includes(val[i])) {
          this.idsval.push(val[i]);
        }
      }
    },
    // toggleSelection() {
    //   var that = this
    //   this.$nextTick(() => {
    //     if (that.$refs.multipleTable) {
    //       console.log(that.$refs.multipleTable);
    //       that.$refs.multipleTable.clearSelection();
    //     }
    //   });
    // },
    //导入数据
    addImport() {
      this.addFormVisible = false;
      for (var i = 0; i < this.idsval.length; i++) {
        this.ids.push(this.idsval[i].id);
      }
      var strs = this.ids.join(",");
      get_import_map_add(strs).then((res) => {
        if (res["code"] === 0) {
          this.getData();
          this.$message.success(res["message"]);
          this.ids = [];
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    // 获取单条
    editMap(row) {
      this.editFormVisible = true;
      get_one_map(row.id, row.company_id).then((res) => {
        if (res["code"] === 0) {
          this.editForm = res.data;
        }
      });
    },
    // 修改地图信息
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          get_map_edit(this.editForm).then((res) => {
            this.editFormVisible = false;
            this.loading = false;
            if (res["code"] === 0) {
              this.getData();
              this.editForm = {};
              this.$message.success(res["message"]);
            }
          });
        } else {
          return false;
        }
      });
    },
    //修改状态
    changeSwitch(row) {
      get_switch_status(row.id, row.company_id, row.status ? 1 : 0).then(
        (res) => {
          if (res["code"] === 0) {
            this.getData();
            this.$message.success(res["message"]);
          }
        }
      );
    },
    delMap(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          get_del_map(row.id, row.company_id).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              if (this.listData.length === 1) {
                if (this.formInline.page === 1) {
                  this.getData();
                } else {
                  this.formInline.page = this.formInline.page - 1;
                  this.getData();
                }
              } else {
                this.getData();
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 车辆
    handleSizeChange(val) {
      this.pagetwo.pageSize = val;
      this.callCar();
    },
    handleCurrentChange(val) {
      this.pagetwo.currentPage = val;
      this.callCar();
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
      this.addFormVisible = false;
    },
  },
};
</script>

<style scoped>
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/map_mn/Map_mn.vue